import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { sizeColumnsToFit } from '@client-shared/ui-agGrid';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { batchTaxEntriesColumnDefs } from '../../shared/columnDefinitions/taxEntriesColumnDefs';
import { alignCenterCellStyle } from '@common/cellStyles';
import taxEntryToImportPropTypes from './taxEntryToImport.propTypes';

import ValidationErrorCellRenderer from './validationErrorCellRenderer.component';

const defaultColumnDefs = {
  ...alignCenterCellStyle,
};

const columnDefs = batchTaxEntriesColumnDefs;

const validationColumnDef = {
  headerName: '',
  field: 'validationError',
  width: 80,
  cellRenderer: ValidationErrorCellRenderer,
};

class BatchTaxEntriesGrid extends PureComponent {
  static propTypes = {
    taxEntriesToImport: PropTypes.arrayOf(taxEntryToImportPropTypes).isRequired,
    chooseTaxEntry: PropTypes.func.isRequired,
    showValidationColumn: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  onGridReady = params => {
    this.gridApi = params.api;
    sizeColumnsToFit(params.api);
  };

  chooseTaxEntry = params => {
    const selectedRows = params.api.getSelectedRows();
    const taxEntry = selectedRows[0];
    this.props.chooseTaxEntry(taxEntry);
  };

  selectFirstRow = params => {
    if (this.props.taxEntriesToImport.length) {
      const deselectOthers = true;
      params.api.getModel().getRow(0).setSelected(true, deselectOthers);
    }
  };

  onRowDataUpdated = params => {
    this.selectFirstRow(params);
    sizeColumnsToFit(params.api);
  };

  render() {
    const {
      taxEntriesToImport,
      isLoading,
      showValidationColumn,
    } = this.props;

    return (
      <div className="batch-tax-entries-grid page-content-container">
        <div className="ag-theme-bootstrap">
          <AgGrid
            columnDefs={showValidationColumn ? [validationColumnDef].concat(columnDefs) : columnDefs}
            defaultColDef={defaultColumnDefs}
            headerHeight={50}
            rowData={taxEntriesToImport}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.chooseTaxEntry}
            onRowDataUpdated={this.onRowDataUpdated}
            isGridLoading={isLoading}
          />
        </div>
      </div>
    );
  }
}

export default BatchTaxEntriesGrid;
